import React, { useCallback, useEffect, useState } from "react";
import {
    DocotorIcon,
    DocotorPairIcon,
} from "../../assets/common-svg/CommonSvg";
import PIApi from "../../services/coordinatingPIService";
import CustomTable from "../../components/custom-table/CustomTable";
import { CustomCard } from "../../components/custom-card/CustomCard";
import { useNavigate, useParams } from "react-router";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import { editorListingDetailData } from "../../utils/tableData";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SubAdminApi from "../../services/subAdminService";
import {  useSelector } from "react-redux";
import moment from "moment";
import { notify } from "../../bmr/utils/methods/notification.js";

const convertSubjectData = (data ,curr_page, page_details, order) => {
  return data?.map((sub,index) => {
    let SerialNo = order=='desc'? (page_details?.no_of_records-((curr_page-1)*10))-index : index+1+((curr_page-1)*10);
    let transformedPatientId = sub?.patient_id || "--";
    let transformedName = sub?.first_name + " " + sub?.last_name || "";
    let transformedPatientStatus =
      sub?.life_status == "lost" ? (
        <div className="h-3 w-3 rounded-full bg-yellow-500"></div>
      ) : sub?.life_status == "alive" ? (
        <div className="h-3 w-3 rounded-full bg-green-500"></div>
      ) : (
        <div className="h-3 w-3 rounded-full bg-red-500"></div>
      )
    let transformedLastVisitType = sub?.last_visit_type||"--"
    let transformedPhase = sub?.phase_name;
    let transformedCount = sub?.appointmentCount;
    let transformCycleCount = sub?.cycle;
    let transformedGender = sub?.gender;
    let transformedId = sub?.id;
    let lastAppointmentDate = sub?.last_appointment_date ? moment(sub?.last_appointment_date).format("DD/MM/YYYY") : "--";
    return [
      SerialNo,
      transformedPatientId,
      transformedName,
      transformedPatientStatus,
      transformedLastVisitType,
      transformedPhase,
      transformedCount,
      transformCycleCount,
      transformedGender,
      lastAppointmentDate,
      transformedId,
    ];
  });
};

export const PiListingDetails = () => {
  const {loginID, assignedPIs, role_slug} =  useSelector((state) => state.loginData.loginId);
  const [loading, setLoading] = useState(false);
  const [loadingDropdown, setLoadingDropdown] = useState(false);
  const [editorDetailedData, setEditorDetailedData] = useState({});
  const [tableFilters, setTablesFilters] = useState({ searchData: "" });
  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentpage] = useState(1);
  const [phaseID, setPhaseID] = useState(null);
  const [order,setOrder] = useState('');
  const [orderBy,setOrderBy] = useState('asc');
  const [subjectData, setSubjectData] = useState(editorListingDetailData);
  const navigate = useNavigate();
  const { id } = useParams();

  // Conditional investigator ID logic
  const getInvestigatorId = () => {
    if (role_slug === "project-manager" && assignedPIs && assignedPIs.length > 0) {
      return assignedPIs;
    } else {
      return loginID;
    }
  };

  const handleNavigateToDetails = useCallback(
    (row) => {
      const UpdatedNavigationArray = location.state;
      UpdatedNavigationArray?.push({
        name: "Patient Details",
        path: `${location.pathname}/patient-details/${row[row?.length - 1]}`,
      });
      navigate(`patient-details/${row[row?.length - 1]}`, {
        state: UpdatedNavigationArray,
      });
    },
    [navigate]
  );

const getEditorDetails = async () => {
  setLoading(true);
  try {
    const investigatorIds = getInvestigatorId();
    
    const params = new URLSearchParams();
    if (investigatorIds && Array.isArray(investigatorIds)) {
      investigatorIds.forEach(id => {
        params.append('investigator_ids[]', id);
      });
    }

    const res = await SubAdminApi.getSubAdminDetails(id, params);
    setEditorDetailedData(res?.data || {});
  } catch (error) {
     notify.error(error)
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    getEditorDetails();
  }, []);

  const GetMatchedKey = (key)=>{
        
    switch (key.trim().toLowerCase()) {
      case 's.no':{
        return 'created_at'
      }    
      case 'patient id':{
        return 'patient_id'
      }    
      case 'patient name':{
        return 'name'
      }    
      case 'patient status':{
        return 'life_status'
      }    
      case 'last recorded visit':{
        return 'last_visit_type'
      }    
      case 'investigator':{
        return 'investigator'
      }    
      case 'editor':{
        return 'editor'
      }    
      case 'phase':{
        return 'phase_name'
      }    
      case 'appointment completed':{
        return 'appointmentCount'
      }    
      case 'cycle no.':{
        return 'cycle'
      }    
      default:{
        return '';
      }
    }
  }

  async function getSubjectList() {
    const sortBy = GetMatchedKey(orderBy);
    const investigatorId = getInvestigatorId(); // Use conditional logic

    try {
      const res = await PIApi.getSubjectList(
        phaseID,
        currentPage,
        10,
        tableFilters?.searchData,
        id,
        investigatorId, // Pass the conditionally determined investigator ID
        "",
        "",
        sortBy,
        order,
      );
      let rowData = convertSubjectData(res?.data || [] ,currentPage, res?.page_details, order);
      setSubjectData((prev) => ({
        ...prev,
        rows: [...rowData],
      }));
      setTotalPage(
        Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit)
      );
      setCurrentpage(res?.page_details?.page);
      setLoadingDropdown(false);
    } catch (error) {
      notify.error(error)
    }
  }

  const handlePagination = async (value) => {
    setCurrentpage(value);
  };

  const handleTableFilters = (e) => {
    setTablesFilters({ ...tableFilters, searchData: e });
  };

  useEffect(() => {
    if (tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " ") {
      setLoadingDropdown(true);
      getSubjectList();
    }
  }, [currentPage, tableFilters, id, phaseID]);

  const handleDropDownChange = (e) => {
    setPhaseID(e.target.value);
  };

  const handleSort = (property)=>{
    const isAsc = orderBy === property && order === 'asc'; // On same column click change order
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  }

  useEffect(()=>{
   if(orderBy){
    getSubjectList();
   }
  },[orderBy,order])

  return (
    <div className="p-2 pt-4 bg-[#F0F1F5]">
      <div className="mb-4 pl-3">
        <BreadCrumb BreadCrumbsListing={[
          {
               name: 'Assigned Principal Investigator',
               path: 'assigned-principal-investigator'
          },
          {   name: 'Details',
               path: location.pathname
          }
        ]} />
      </div>

      <div className="pl-3 pr-3">
        {" "}
        {loading ? (
          <div className="col-start-1 col-end-4 ">
            <SkeletonLoader rowCount={1} isTable={false} height={160} />
          </div>
        ) : (
          <>
            {" "}
            <CustomCard
              MainHeading={editorDetailedData?.name}
              SubHeading={`${editorDetailedData?.email || ""}  |  ${
                editorDetailedData?.role || ""
              }`}
              main_heading_class={"font-bold"}
              NoWrap={true}
              DetailsArray={
                [
                ]
              }
              startIcon={<DocotorIcon Height="50px" Width="52px" />}
              endIcon={<DocotorPairIcon />}
              ArrayLowGapBoolean={true}
              chartData={editorDetailedData?.phaseDetails || []}
              hideEditDelete={true}
            />{" "}
          </>
        )}
      </div>
      <CustomTable
        rows={subjectData?.rows}
        columnAlign={subjectData?.columnAlign}
        columns={subjectData?.columns}
        TableData={subjectData?.TableData}
        handleNavigate={handleNavigateToDetails}
        handleTableFilters={handleTableFilters}
        tableFilters={tableFilters}
        handleChangePage={handlePagination}
        loading={loadingDropdown}
        currentPage={currentPage}
        totalpage={totalPage}
        dropDownValue={phaseID}
        handleChangeDropDown={handleDropDownChange}
        order={order}
        orderBy={orderBy}
        EnableSorting={true}
        handleSort ={handleSort}
      />
    </div>
  );
};